exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quick-link-manager-page[data-v-c0173828]{padding:0}.quick-link-manager-page__header[data-v-c0173828]{display:flex;justify-content:space-between;align-items:center}.quick-link-manager-page__header-actions[data-v-c0173828]{display:flex;align-items:center;gap:8px}.quick-link-manager-page__header--inner[data-v-c0173828]{margin-bottom:10px}.quick-link-manager-page__header--only-actions[data-v-c0173828]{justify-content:flex-end}.quick-link-manager-page__tax-top-actions[data-v-c0173828]{display:flex;justify-content:flex-end;margin-bottom:8px}.quick-link-manager-page__tabs[data-v-c0173828] .el-tabs__content{padding-top:10px}.full-width[data-v-c0173828]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c0173828","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/QuickLinkManager.vue
// module id = org6
// module chunks = 0